/*
 * 请求封装
 * @Author: Evan.Xu 
 * @Date: 2020-05-25 16:58:04 
 * @Last Modified by: Evan.Xu
 * @Last Modified time: 2020-09-10 14:11:48
 */

import request from './request';
import qs from 'qs';

// POST请求
const post = (url, data = {}, configs = {}) => {
  let formatData = qs.stringify(data);
  return request({
    method: 'post',
    url: url,
    data: formatData,
    ...configs,
    // 请求预处理函数 可以把你传的param进行处理
    // transformRequest: [
    //   (data) => {
    //     // data 就是post请求传的值
    //     let params = '';
    //     for (var index in data) {
    //       params += index + '=' + data[index] + '&';
    //     }
    //     // 判断最后一个字符串是否为&，为真则删除最后一个字符串
    //     if (params.charAt(params.length - 1) === '&') {
    //       params = params.substring(0, params.length - 1);
    //       return params;
    //     } else {
    //       return params;
    //     }
    //   },
    // ],
  });
};

// GET请求
const get = (url, data = {}, configs = {}) => {
  return request({
    method: 'get',
    url: url,
    params: data,
    ...configs,
  });
};

const req_get = (url, payload, configs = {}) => {
  return new Promise((resolve) => {
    get(url, {
      ...payload,
    }, configs).then(response => {
      resolve(response);
    }).catch(error => {
      resolve({
        code: 1001,
        msg: error.message,
      });
    });
  });
};
const req_post = (url, payload, configs = {}) => {
  return new Promise((resolve) => {
    post(url, {
      ...payload,
    }, configs).then(response => {
      resolve(response);
    }).catch(error => {
      resolve({
        code: 1001,
        msg: error.message,
      });
    });
  });
};
export default {
  post,
  get,
  req_get,
  req_post,
};